import React from 'react'
import { Box } from '@mui/material'

interface TutorialImageProps {
  size?: number
  className?: string
}

/**
 * TutorialImage - Uses the actual tutorial_image.png from public assets
 * Shows the exact network diagram image as provided
 */
export const TutorialImage: React.FC<TutorialImageProps> = ({ size = 120, className = '' }) => {
  return (
    <Box
      className={className}
      sx={{
        width: `${size}px`,
        height: `${size}px`,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src="/assets/img/tutorial_image.png"
        alt="Game Tutorial"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
      />
    </Box>
  )
}
